import React from "react";
import "./CustomDropdown.css";

interface CustomDropdownProps {
  prompt?: string;
  value?: string;
  options?: Array<{ value: string, name: string }>;
  onChange: (value: string) => void;}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ prompt, value, options = [], onChange }) => {
  // Handle the change event from the select element
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    onChange(newValue); // Call the parent's onChange handler
  };

  return (
    <select 
      className="custom-dropdown-select"
      value={value || ''} 
      onChange={handleChange}
      aria-label={prompt || 'Select one'}
    >
      {/* Default placeholder option */}
      {/* !value && <option value="" disabled>{text}</option> */}
      <option value="" disabled>{`-- ${prompt || 'Select one'}`}</option>
      
      {/* Map through the provided options */}
      {options.map((option) => (
        <option 
          key={option.value} 
          value={option.value}
        >
          {option.name}
        </option>
      ))}
    </select>
  );
};

export default CustomDropdown;